module.exports = __webpack_public_path__ + "static/media/cat.1d0aa4c5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Aboutme/cat.jpeg
// module id = 1140
// module chunks = 0